import React, { useEffect } from 'react';
import MoreActivitySection from "../sections/common/MoreActivitySection";

import StreamingSection from "../sections/streaming/StreamingSection";
import CrosssiteSalesSection from "../sections/streaming/CrosssiteSalesSection";
import CrosssiteBannerSection from '../sections/common/CrosssiteBannerSection';
import Seo from "../components/SEO"

import { graphql } from 'gatsby';
import { useLocalization } from "gatsby-theme-i18n";


const StreamingPage = ({ data }) => {
  const { t, addString, localeKey } = useLocalization();


  useEffect(() => {
    addString('home',data.allHomeCsv.nodes);
    addString('streaming',data.allStreamingCsv.nodes);
    addString('program_timetable',data.allProgramTimetableCsv.nodes)
    addString('guest',data.allGuestCsv.nodes)
  },[addString,data]);

  return (<div>
    <Seo 
      title={data.pageTitle[localeKey]} 
      description={data.pageDescription[localeKey]}  />  
    <StreamingSection />
    <CrosssiteSalesSection />
    <MoreActivitySection title={t('streaming.activity.title')} category={t('streaming.activity.subtitle')}/>
    <CrosssiteBannerSection />
  </div>);
}
 
export default StreamingPage;

export const query = graphql`
  query StreamingPageQuery {
    pageTitle : streamingCsv(key: {regex: "/^page.title/"}) {
      ...localizedContent
    }
    pageDescription :streamingCsv(key: {regex: "/^page.description/"}) {
      ...localizedContent
    }

    allHomeCsv {
      nodes {
        ...localizedContent
      }
    }

    allProgramTimetableCsv {
      nodes {
        ...localizedContent
      }
    }

    allGuestCsv {
      nodes {
        ...localizedContent
      }
    }

    allStreamingCsv {
      nodes {
        ...localizedContent
      }
    }
  }
`
